// eslint-disable-next-line import/prefer-default-export
export const SEARCH_SEARCH_LINE_SET_DATA = 'SEARCH_SEARCH_LINE_SET_DATA';
export const SEARCH_SEARCH_BOOKS_SET_DATA = 'SEARCH_SEARCH_BOOKS_SET_DATA';
export const SEARCH_SEARCH_BOOKS_RESET_DATA = 'SEARCH_SEARCH_BOOKS_RESET_DATA';

export const SEARCH_SEARCH_AUTHORS_SET_DATA = 'SEARCH_SEARCH_AUTHORS_SET_DATA';
export const SEARCH_SEARCH_AUTHORS_RESET_DATA = 'SEARCH_SEARCH_AUTHORS_RESET_DATA';

export const SEARCH_SEARCH_GENRES_AND_THEMES_SET_DATA = 'SEARCH_SEARCH_GENRES_AND_THEMES_SET_DATA';
export const SEARCH_SEARCH_GENRES_AND_THEMES_RESET_DATA = 'SEARCH_SEARCH_GENRES_AND_THEMES_RESET_DATA';

export const SEARCH_SEARCH_SERIES_SET_DATA = 'SEARCH_SEARCH_SERIES_SET_DATA';
export const SEARCH_SEARCH_SERIES_RESET_DATA = 'SEARCH_SEARCH_SERIES_RESET_DATA';

export const SEARCH_SEARCH_BOOKSETS_SET_DATA = 'SEARCH_SEARCH_BOOKSETS_SET_DATA';
export const SEARCH_SEARCH_BOOKSETS_RESET_DATA = 'SEARCH_SEARCH_BOOKSETS_RESET_DATA';

export const SEARCH_SEARCH_AUDIO_BOOKS_SET_DATA = 'SEARCH_SEARCH_AUDIO_BOOKS_SET_DATA';
export const SEARCH_SEARCH_AUDIO_BOOKS_RESET_DATA = 'SEARCH_SEARCH_AUDIO_BOOKS_RESET_DATA';

export const SEARCH_SEARCH_RIGHTHOLDERS_SET_DATA = 'SEARCH_SEARCH_RIGHTHOLDERS_SET_DATA';
export const SEARCH_SEARCH_RIGHTHOLDERS_RESET_DATA = 'SEARCH_SEARCH_RIGHTHOLDERS_RESET_DATA';
